/* @flow */
import FleetioLogo from '../../assets/icons/integrations/Fleetio.svg';

const INTEGRATIONS = [
    {
        id: 'fleetio',
        name: 'Fleetio',
        logo: FleetioLogo,
        subtitle: 'Send odometer readings, engine hours, and vehicle fault codes from FleetLocate to Fleetio.',
        path: '/integrations/fleetio',
    },
];

export default INTEGRATIONS;
